import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';

import { getSimpleStatus, formatReleaseDate } from 'components/editor/pages/focus/landing/utils';
import Image from 'components/image/image';

import s from 'components/editor/pages/focus/landing/moviesExplorer.sss';

export default class MoviesExplorer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			search: '',
			results: [],
			pageSize: 15,
			page: 0,
		};

		this.renderMovie = this.renderMovie.bind(this);

		this.updateResults(props);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.movies !== this.props.movies) {
			this.updateResults(nextProps);
		}
	}

	updateResults(props = this.props) {
		this.setState({ results: props.movies || [], page: 0 });
	}

	renderControls() {
		return (
			<form class={s.controls}>
				<details
					class={s.type}
					role="combobox"
					aria-haspopup="listbox"
					aria-labelledby="select-film-type-label"
				>
					<summary id="select-film-type-label">
						All Films
					</summary>
				</details>

				<label class={s.search}>
					<input type="text" name="search" placeholder="SEARCH..." aria-label="Search films" disabled />
				</label>
			</form>
		);
	}

	renderMovie(movie) {
		const isPlaceholder = movie.placeholder === true || null;
		const heroImageUrl = movie.hero?.still?.url || movie.heroImage || `${__IMAGE_ROOT__}/focus-default.jpg`;
		const heroImageAlt = movie.hero?.still?.alt || `Poster for ${movie.title}${movie.dates?.release ? ` (${movie.dates.release.slice(0, 4)} Movie)` : ''}`;
		const heroFocalPoint = movie.hero?.still?.focalPoint;
		const detailsFull = [movie.rating, formatReleaseDate(movie.dates?.release), movie?.genres?.base?.join(', ')]
			.filter(Boolean)
			.join(' | ');
		const detailsPlaceholder = movie?.genres?.base?.join(', ');
		const details = isPlaceholder ? detailsPlaceholder : detailsFull; 

		return (
			<div class={s.movie} key={movie.slug}>
				<div class={s.preview} tabIndex="-1">
					{!!heroImageUrl && <Image alt={heroImageAlt} src={heroImageUrl} focalPoint={heroFocalPoint} />}
					<div class={s.status}>{getSimpleStatus(movie)}</div>
				</div>
				<div class={s.title}>
					{movie.title}
				</div>
				<div class={s.details}>{details}</div>
			</div>
		);
	}

	renderResults() {
		const from = this.state.page * this.state.pageSize;
		const displayedResults = this.state.results.slice(from, from + this.state.pageSize);

		return (
			<div class={s.results}>
				{displayedResults.map(this.renderMovie)}
				{this.props.loading === 'loaded' && !this.state.results.length && <div class={s.noResults}>No films match your filters/search.</div>}
			</div>
		);
	}

	renderPagination() {
		if (this.state.results.length <= this.state.pageSize) return;
		const totalPages = Math.ceil(this.state.results.length / this.state.pageSize);
		const page = this.state.page;
		let displayedPages = [];

		if (totalPages <= 7) {
			displayedPages = [...Array(totalPages).keys()];
		} else {
			displayedPages = [0];
			if (page < 4) displayedPages.push(1, 2, 3, 4, '…');
			else if (page > totalPages - 5) displayedPages.push('…', totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2);
			else displayedPages.push('…', page - 1, page, page + 1, '…');
			displayedPages.push(totalPages - 1);
		}

		return (
			<div class={s.pagination}>
				<button type="button" class={s.prev} disabled aria-label="Previous page">
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none">
						<path d="M12.9951 1.52002L1.49512 13.02L12.9951 24.52" />
					</svg>
				</button>
				{displayedPages.map((p) =>
					p === '…' ? (
						<span>…</span>
					) : (
						<button
							type="button"
							class={joinClasses(p === page && s.current)}
							value={p}
							disabled
							aria-label={p === page ? `Current page, page ${p + 1}` : `Go to page ${p + 1}`}
							key={p}
						>
							{p + 1}
						</button>
					)
				)}
				<button type="button" class={s.next} disabled aria-label="Next page">
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none">
						<path d="M0.995117 1.52002L12.4951 13.02L0.995117 24.52" />
					</svg>
				</button>
			</div>
		);
	}

	render() {
		return (
			<div class={s.wrapper}>
				{this.renderControls()}
				{this.renderResults()}
				{this.renderPagination()}
			</div>
		);
	}
}
